// Third party components
import React, { useEffect } from 'react'
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom'

// App components
import { Provider } from './app_context'
import CartPage from './page_cart'
import CheckoutPage from './page_checkout'
import ConfirmationPage from './page_confirmation'
import HomePage from './page_home'
import { PageLogin } from './page_login'
import { PageRegister } from './page_register'
import PageProfile from './page_profile'
import PageAdmin from './page_admin'
import NotFoundPage from './page_not_found'
import TestPage from './page_test'
import TrackOrderPage from './page_track_order'

// Styles
import 'semantic-ui-css/semantic.min.css'
import '../../css/index.sass'

// Route tracking component
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page views with Faro
    if (window.faroTracker) {
      window.faroTracker.trackPageView(location.pathname);
      
      // Track conversion funnel steps
      switch (location.pathname) {
        case '/':
          window.faroTracker.trackConversionStep('homepage_visit');
          break;
        case '/login':
          window.faroTracker.trackConversionStep('login_page');
          break;
        case '/register':
          window.faroTracker.trackConversionStep('registration_page');
          break;
        case '/profile':
          window.faroTracker.trackConversionStep('profile_page');
          break;
        case '/cart':
          window.faroTracker.trackConversionStep('cart_view');
          break;
        case '/checkout':
          window.faroTracker.trackConversionStep('checkout_start');
          break;
        case '/confirmation':
          window.faroTracker.trackConversionStep('order_complete');
          break;
        default:
          if (location.pathname.startsWith('/track/')) {
            window.faroTracker.trackConversionStep('order_tracking');
          }
          break;
      }
    }
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Provider>
      <BrowserRouter>
        <RouteTracker />
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Route path="/login" exact component={PageLogin} />
          <Route path="/register" exact component={PageRegister} />
          <Route path="/profile" exact component={PageProfile} />
          <Route path="/admin" exact component={PageAdmin} />
          <Route path="/cart" exact component={CartPage} />
          <Route path="/checkout" exact component={CheckoutPage} />
          <Route path="/confirmation" exact component={ConfirmationPage} />
          <Route path="/track/:orderId" exact component={TrackOrderPage} />
          <Route path="/test" exact component={TestPage} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </BrowserRouter>
    </Provider>
  )
}

export default App
